import React from "react";
import { Nav } from "react-bootstrap";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import Authorize from "../../utilities/Authorize";
import authUtility from '../../utilities/AuthUtility';

interface IOpenConfigCard {
  openConfigCard: () => void;
  openSampleCard: () => void;
}

export default class AppNavbar extends React.Component<IOpenConfigCard, any> {
  render() {
    let activeKey = "";
    switch (true) {
      case window.location.pathname.toString().includes("dashboard"):
        activeKey = "dashboard";
        break;
      case window.location.pathname.toString().includes("trends"):
        activeKey = "trends";
        break;
      case window.location.pathname.toString().includes("sample") ||
        window.location.pathname.toString() === "/":
        activeKey = "sample";
        break;
      default:
        activeKey = "settings";
        break;
    }
    return (
      <Translation>
        {(t) => (
          <Nav className="justify-content-center" activeKey={activeKey}>
            {authUtility.hasPermission([`${CONSTANTS.AUTHKEY_DASHBOARD}`]) &&
            authUtility.hasPermission([`${CONSTANTS.AUTHKEY_SAMPLE_MODE}`]) &&
              <Nav.Item>
                <Nav.Link href="/dashboard" eventKey="dashboard">
                  {t(CONSTANTS.MENU_DASHBOARD)}
                </Nav.Link>
              </Nav.Item>}
            {authUtility.hasPermission([`${CONSTANTS.AUTHKEY_SAMPLE_MODE}`,`${CONSTANTS.AUTHKEY_INSTRUMENT}`]) &&
            <Nav.Item>
              <Nav.Link eventKey="sample" onClick={this.props.openSampleCard}>
                {t(CONSTANTS.MENU_SAMPLE)}
              </Nav.Link>
            </Nav.Item>}
            <Authorize scopes={[`${CONSTANTS.AUTHKEY_TRENDS}`]}>
              <Nav.Item>
                <Nav.Link href="/trends" eventKey="trends">
                  {t(CONSTANTS.MENU_TREND_ANALYSIS)}
                </Nav.Link>
              </Nav.Item>
            </Authorize>
            {authUtility.hasPermission([`${CONSTANTS.AUTHKEY_PROPERTY}`,
                  `${CONSTANTS.AUTHKEY_INSTRUMENT_TYPE}`,`${CONSTANTS.AUTHKEY_INSTRUMENT}`,
                  `${CONSTANTS.AUTHKEY_SOURCE}`,`${CONSTANTS.AUTHKEY_TEST_PLAN}`,
                  `${CONSTANTS.AUTHKEY_GRADE}`,`${CONSTANTS.AUTHKEY_PRODUCT}`,
                  `${CONSTANTS.AUTHKEY_INSTRUMENT_STATION}`,`${CONSTANTS.AUTHKEY_ROLES}`,
                  `${CONSTANTS.AUTHKEY_USERS}`,`${CONSTANTS.AUTHKEY_SETTINGS}`,
                  `${CONSTANTS.AUTHKEY_SCANNER}`,`${CONSTANTS.AUTHKEY_BACKUP_RESTORE}`]) &&
            <Nav.Item>
              <Nav.Link eventKey="settings" onClick={this.props.openConfigCard}>
                {t(CONSTANTS.MENU_CONFIG)}
              </Nav.Link>
            </Nav.Item>}
          </Nav>
        )}
      </Translation>
    );
  }
}
